import { createSelector } from "reselect";
import { ResidentActiveStatus, ResidentBedStatus, ResidentStatusMap } from ".";
import { Resident } from "../residents";
import { residentsSlicedBySelectedMonitorNode } from "../residents/selectors";
import { IAppState } from "../types";
export const activityStatusCreator = () => {
  return createSelector(
    (state: IAppState): ResidentStatusMap =>
      state.residentStatuses.activityStatuses,
    (_: IAppState, residentId: string): string => residentId,
    (residentStatuses, residentId) => {
      return residentStatuses[residentId] as ResidentActiveStatus;
    }
  );
};

export const bedStatusCreator = () => {
  return createSelector(
    (state: IAppState): ResidentStatusMap => state.residentStatuses.bedStatuses,
    (_: IAppState, residentId: string): string => residentId,
    (residentStatuses, residentId) => {
      return residentStatuses[residentId] as ResidentBedStatus;
    }
  );
};

export const bedStatusesSlicedByMonitorNode = createSelector(
  residentsSlicedBySelectedMonitorNode,
  (state: IAppState): ResidentStatusMap => state.residentStatuses.bedStatuses,
  (residents, bedStatuses) => {
    const resultStatuses = {};
    residents.map((res: Resident) => {
      if (bedStatuses[res.id]) resultStatuses[res.id] = bedStatuses[res.id];
      return null;
    });
    return resultStatuses;
  }
);
